import AppHelper from '@Common/ApplicationCore/AppHelper';
import { ApplicationGuard } from '@Common/ApplicationCore/ApplicationGuard';
import Guid from '@Common/Core/Guid';
import Maybe from '@Common/Core/Maybe';
import { ApplicationType } from '@Common/Enums';
import documentHelper from '@Common/Helpers/DocumentHelper';
import { BaseStyle, InsightMetaModel } from '@InstanceFactory';
import { enumerable } from '@Common/Core/CoreDecorator';
import constants from '../Core/Constant';
import urlHelper from './UrlHelper';

export class ThemeHelper {
    private currentThemeId: string;

    constructor(themeId: string = ThemeHelper.getCurrentThemeId()) {
        this.currentThemeId = themeId;
    }

    @enumerable
    private static get insightMeta(): InsightMetaModel {
        return (altosoft.model.insightMeta = altosoft.model.insightMeta || ({} as any));
    }

    public static getStyles(themeId: string = ThemeHelper.getCurrentThemeId()): BaseStyle[] {
        return Maybe(ThemeHelper.insightMeta)
            .read(meta => meta.stylesByTheme)
            .read(stylesByTheme => stylesByTheme[themeId])
            .valueOrDefault([]);
    }

    public static getCurrentThemeId(): Guid {
        try {
            if (ApplicationGuard.is(ApplicationType.studio, ApplicationType.viewer)) {
                return this.getDefaultThemeId(AppHelper.projectId);
            }
        } catch {
            return ThemeHelper.insightMeta.currentThemeId;
        }
    }

    public static getDefaultThemeId(projectId: Guid): Guid {
        const projectModel = documentHelper.getProject(projectId);
        if (!projectModel) {
            throw new Error(`Project model for projectId : ${projectId} is not loaded`);
        }
        const themes = projectModel.configurationSettings?.projectThemes ?? {};
        return themes[Guid.empty] || ThemeHelper.insightMeta.currentThemeId;
    }

    public static changeTheme(themeId: string): void {
        const parameters = {};
        parameters[constants.themeIdParameter] = themeId;
        urlHelper.refresh(parameters);
    }
}
